import React, { useState, useEffect } from 'react';
import { Typography, Grid, makeStyles } from '@material-ui/core';
import L from 'leaflet';
import { alertIcon } from './Icons';
import axios from 'axios';
import config from '../../../config/config.json';

const useStyles = makeStyles((theme) => ({
    alertsMap: {
        height: 700,
        marginBottom: theme.spacing(2),
    },
}));

export default function (props) {
    const classes = useStyles();

    const [alerts, setAlerts] = useState([]);
    const [map, setMap] = useState({});

    function loadMap() {
        let map = L.map('alertsMap', {
            maxBounds: L.latLngBounds([30, -93], [13, -60]),
            minZoom: 7,
            fullscreenControl: true,
            timeDimension: true,
            timeDimensionControl: true,
            timeDimensionControlOptions: {
                autoPlay: false,
                minSpeed: 0.5,
                speedStep: 0.5,
                maxSpeed: 5,
                playerOptions: {
                    buffer: 10,
                    transitionTime: 1000,
                    loop: true,
                }
            }
        }).setView([20.15, -76.15], 10);

        let OSM_CMP = L.tileLayer(`${config.baseUrl}/mapas/osm_tiles/{z}/{x}/{y}.png`, { //wwww.cmpscu.cu/mapas
            attribution: 'Map data: &copy; <a target="_blank" href="https://www.openstreetmap.org/copyright">Colaboradores de OpenStreetMap</a> | &copy; <a target="_blank" href="http://www.cmpscu.cu/" title="Servidor de Mapas CMP Santiago de Cuba">Meteorología Santiago de Cuba</a>',
            bounds: L.latLngBounds([53, -138], [-3, -22]),
            minZoom: 7,
        });
        OSM_CMP.addTo(map);

        return map;
    }

    function addMarkerToMap(map, position, icon, text) {
        var marker = L.marker(position, { icon: icon }).addTo(map);
        marker.bindPopup(text);
    }

    useEffect(() => {
        // effect
        const url = `${config.apiBaseUrl}/alertas`;
        async function fetchAlerts() {
            let response = await axios.get(url);
            console.log(response.data);
            setAlerts(response.data);
        }
        fetchAlerts();

        setMap(loadMap());

        return () => {
            // cleanup
        }
    }, [])

    useEffect(() => {
        // effect
        alerts.map((alert) => {
            addMarkerToMap(map, [alert.municipio.lat, alert.municipio.long], alertIcon(alert.nombre), `<b>${alert.nombre}</b><br>Riesgo: <i>${alert.riesgo}</i><br><i>${alert.municipio.nombre}</i>`);
        })

        return () => {
            // cleanup
        }
    }, [alerts])

    return (
        <main style={{ paddingTop: 88 }}>
            <Typography variant="h4" color="initial" className="efecto-espejo" style={{ marginBottom: 10 }}>
                Alertas
            </Typography>

            <Grid
                container
                spacing={1}
                direction="row"
                justify="center"
                alignItems="center"
                alignContent="center"
                wrap="nowrap"

            >
                <Grid item xs={10}>
                    <div className={classes.alertsMap} id="alertsMap">

                    </div>
                </Grid>
            </Grid>
        </main>
    )
}